export function getRefreshTokenLifeSeconds(refreshTokenExpirationDate: string): number {
    const milliseconds = new Date(refreshTokenExpirationDate).getTime() - new Date().getTime();
    return Math.round((milliseconds / 1000));
}
